export const ru = {
    add: 'Добавить',
    edit: 'Изменить',
    'upload-error': 'Недопустимый тип файла, используйте графические форматы JPEG, PNG',
    'upload-source': 'Загрузить с компьютера'
};
